'use es6';

import { logDebug, logError } from './hspbUtils';
const REPORTING_PATH = '/activity';
const CLICK_ACTIVITY_PATH = `${REPORTING_PATH}/click`;
const VIEW_ACTIVITY_PATH = `${REPORTING_PATH}/view`;
const postActivity = (url, activity) => {
  if (!url) {
    logError('Missing apiBaseUrl from the banner. Failed to send activity event.');
    return;
  }
  const xhr = new XMLHttpRequest();
  xhr.open('POST', url, true);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.onreadystatechange = function () {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      if (xhr.status === 200 || xhr.status === 204) {
        logDebug('successfully sent reporting activity');
      } else {
        logError(`error sending reporting activity request status: ${xhr.status}`);
      }
    }
  };
  xhr.send(JSON.stringify(activity));
};
export const sendClickActivity = (apiBaseUrl, clickActivity) => {
  const url = apiBaseUrl ? `${apiBaseUrl}${CLICK_ACTIVITY_PATH}` : null;
  postActivity(url, clickActivity);
};
export const sendViewActivity = (apiBaseUrl, viewActivity) => {
  const url = apiBaseUrl ? `${apiBaseUrl}${VIEW_ACTIVITY_PATH}` : null;
  postActivity(url, viewActivity);
};